import * as React from 'react';

import {useGetSalesProcessContext} from '../graphql/hooks';
import {updateSalesProcessContext, SALES_PROCESS_AGENT} from '../helpers';
import type {Chatbot} from '../helpers';
import {TeamAiAgent} from '../team-ai-agent';

type Props = {
    pageContext: string | null | undefined;
};

export function SalesProcessAgent(props: Props) {
    const {context: salesContext} = useGetSalesProcessContext();

    let onInitializeChatbot;
    if (salesContext) {
        onInitializeChatbot = (chatbot: Chatbot): void => {
            updateSalesProcessContext(chatbot, salesContext);
        };
    } else {
        onInitializeChatbot = null;
    }

    return (
        <TeamAiAgent
            agentKey={SALES_PROCESS_AGENT}
            // @ts-expect-error
            onInitializeChatbot={onInitializeChatbot}
            pageContext={props.pageContext}
        />
    );
}
